<template>
  <Modal v-model="productStatusSyncRulesModal" :title="productStatusSyncRulesTitle" width="500" :transfer="false"
    :mask-closable="false" @on-visible-change="productStatusSyncRulesChange">
    <Form ref="productStatusSyncRulesForm" :model="productStatusSyncRulesForm" :rules="ruleValidate"
      :label-width="90" @submit.native.prevent>
      <Row style="width: 95%;">
        <h2 class="font-weight-bold mb8 font-size-14 flex align-items-center pl29">
          {{ $t('key1005651') }}
        </h2>
        <Checkbox v-model="productStatusSyncRulesForm.syncinventoryToZero" class="mb10 ml30 font-size-13" :true-value="1" :false-value="0">
          {{ $t('key1005628') }}
        </Checkbox>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1005351')" prop="platformIds">
            <Select v-model="productStatusSyncRulesForm.platformIds" multiple filterable transfer :placeholder="$t('key1005631')">
              <Option v-for="item in platformList" :value="item.platformId">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
        <div class="flex flex-direction ml30 mb10 font-size-13">
          <Checkbox v-model="productStatusSyncRulesForm.syncproductToListing" :true-value="1" :false-value="0">
            {{ $t('key1005629') }}
          </Checkbox>
          <span class="mt4 font-size-12">{{ $t('key1005652') }}</span>
        </div>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001522')" :label-width="68" prop="status" class="radio_styles_distributor">
            <RadioGroup v-model="productStatusSyncRulesForm.status">
              <Radio :label="1">{{ $t('key1000462') }}</Radio>
              <Radio :label="0">{{ $t('key1000463') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="productStatusSyncRulesModal = false">{{ $t('key1000112') }}</Button>
      <Button :disabled="productStatusSyncRulesForm.syncproductToListing === 0 && productStatusSyncRulesForm.syncinventoryToZero === 0"
        type="primary" @click="productStatusSyncRulesBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import * as JOSN from "echarts";

export default {
  name: "productStatusSyncRulesModal",
  mixins: [Mixin],
  props: {
    platformList: { // 适用平台
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      productStatusSyncRulesModal: false,
      productStatusSyncRulesTitle: '',
      productStatusSyncRulesForm: {
        platformIds: [],
        syncinventoryToZero: 1,
        syncproductToListing: 0,
        status: 1
      },
      ruleValidate: {
        platformIds: [
          {type: 'array', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005631'), trigger: 'change'}
        ],
      },
      autoRuleId: null,
      ruleType: null,
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  methods: {
    // 初始化数据
    initProductStatusSyncRulesData(type, autoRuleId) {
      let obj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005649'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005650')
      };
      this.ruleType = type;
      this.productStatusSyncRulesTitle = obj[type];
      if (type === 'edit') {
        this.getProductStatusSyncRulesData(autoRuleId);
      } else {
        this.productStatusSyncRulesModal = true;
      }
    },
    // 获取规则详情数据
    getProductStatusSyncRulesData(autoRuleId) {
      let v = this;
      v.axios.get(api.get_ymsProductStatusSynRule + autoRuleId, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.autoRuleId = data.autoRuleId;
            v.productStatusSyncRulesForm.status = data.status;
            let autoRuleActionResults = data.ruleActions || [];
            if (autoRuleActionResults.length > 0) {
              autoRuleActionResults.map((ele) => {
                if (ele.type === 'PRODUCT_STATUS_SYN_RULE') {
                  let obj = JSON.parse(ele.value);
                  let ruleAction = obj.ruleAction || [];
                  v.productStatusSyncRulesForm.platformIds = [obj.platformId] || [];
                  if (ruleAction.length > 0) {
                    ruleAction.map((key) => {
                      v.productStatusSyncRulesForm[key] = 1;
                    });
                  }
                }
              });
            }
            v.productStatusSyncRulesModal = true;
          }
        }
      });
    },
    // 保存按钮
    productStatusSyncRulesBtn() {
      let v = this;
      let ruleAction = [];
      let query = {};
      let url = '';
      let method = '';
      let text = '';
      let keyList = ['syncinventoryToZero', 'syncproductToListing'];
      keyList.map((item) => {
        if (v.productStatusSyncRulesForm[item] === 1) {
          ruleAction.push(item);
        }
      });
      let values = {
        ruleAction: ruleAction,
        platformIds: v.productStatusSyncRulesForm.platformIds
      };
      query = {
        autoRuleActions: [
          {
            type: 'PRODUCT_STATUS_SYN_RULE',
            value: JSON.stringify(values)
          }
        ],
        businessId: v.userInfo.merchantId, // 落到商户级别
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005620'),
        status: v.productStatusSyncRulesForm.status
      };
      if (v.ruleType === 'add') {
        url = api.post_ymsProductStatusSynRule_insert;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113');
      } else {
        url = api.put_ymsProductStatusSynRule_update;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161');
        query.autoRuleId = v.autoRuleId;
      }
      v.$refs['productStatusSyncRulesForm'].validate((valid) => {
        if (valid) {
          v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.productStatusSyncRulesModal = false;
              v.$Message.success(text);
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    productStatusSyncRulesChange(value) {
      if (!value) {
        this.$refs['productStatusSyncRulesForm'].resetFields();
        this.productStatusSyncRulesForm.syncinventoryToZero = 1;
        this.productStatusSyncRulesForm.syncproductToListing = 0;
        this.autoRuleId = null;
        this.ruleType = null;
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ivu-form-item-label, label {
  font-size: 13px !important;
}
</style>